export const ENTITLEMENT_RELATIONSHIP_TYPE_COLLECTION = 'COLLECTION';

export const COLLECTION_TYPE_TEAMWORK = 'Teamwork Collection';
export const COLLECTION_TYPE_SERVICE = 'Service Collection';

export type CollectionType = typeof COLLECTION_TYPE_TEAMWORK | typeof COLLECTION_TYPE_SERVICE;
